// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"EvaluationsCompany_tabsContainer__DTvMo"};